import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { IWorkflowTriggerList, WorkflowTrigger } from '../models/workflow-trigger';
import { SubjectTypeService } from './subject-type.service';
import { LookupService } from './lookup.service';
@Injectable({ providedIn: 'root'})
export class WorkflowTriggerService extends BaseRestService<WorkflowTrigger, IWorkflowTriggerList>{

  constructor(http: HttpClient, protected router: Router) {
    super(WorkflowTriggerService, http, 'api/workflowtriggers', 'workflow trigger', router);

    // enable caching
    this.cacheEnabled = true;
  }

  // getAllData(): Observable<WorkflowTrigger[]>{
  //   const triggers: WorkflowTrigger[] = [];
  //   return this.createOrUpdateTriggers(triggers);
  // }

  // createOrUpdateTriggers(triggers: WorkflowTrigger[]): Observable<WorkflowTrigger[]>{
  //   //   const ptrigger = this.createTrigger(i, 'Process', 200);
  //   //   // const pEventFilter = new WorkflowEventFilterItem();
  //   //   // pEventFilter.id = 1;
  //   //   // pEventFilter.name = 'Process Type';
  //   //   // pEventFilter.required = false;
  //   //   // pEventFilter.values = [{
  //   //   //   id: '1',
  //   //   //   name: 'Financial',
  //   //   // }];
  //   //   // ptrigger.eventFilters.push(pEventFilter);
  //   //   triggers.push(ptrigger);
  //   // });
  //   return this.createOrUpdateSubjectTriggers(triggers);
  // }

  // private createOrUpdateSubjectTriggers(triggers: WorkflowTrigger[]){
  //   return this.subjectTypeService.getAllData().pipe(take(1)).map((subjectTypes) => {
  //     if (subjectTypes){
  //       subjectTypes = subjectTypes.sort((a, b) => a.name.localeCompare(b.name));
  //       const ev = Utilities.enumToList(enumWorkflowEntityEvent, true);
  //       subjectTypes.map((s) => {
  //         const recipe = {
  //           id: s.id,
  //           ingredients: [],
  //         };
  //         s.dataFields.map((d) => {
  //           const ingredient = {
  //             id: d.id,
  //             recipeId: s.id,
  //             name: d.label,
  //             ingredientTypeId: enumWorkflowIngredientType.Property,
  //             values: [],
  //             dataType: d.dataType,
  //           };
  //           if (!isNaN(Number(d.dataType))){
  //             this.lookupService.getAllByLookupType(Number(d.dataType)).subscribe((lookups) => {
  //               ingredient.values.push(...lookups.sort((a, b) => a.description.localeCompare(b.description)).map((i) => i.description));
  //               recipe.ingredients.push(ingredient);
  //             });
  //           }
  //           else{
  //             recipe.ingredients.push(ingredient);
  //           }
  //         });
  //         ev.map((e) => {
  //           const trigger = new WorkflowTrigger({
  //             id: (s.id * 20) + e.id,
  //             category: s.name,
  //             eventId: e.id,
  //             event: e.name,
  //             recipeId: s.id,
  //             recipe,
  //           });
  //           triggers.push(trigger);
  //         });
  //       });

  //       //   subjectTypes.map((s) => {
  //       //     f.values.push({id: s.id, name: s.name});
  //       //     s.dataFields.map((d) => {
  //       //       const q = new WorkflowQueryItem();
  //       //       q.id = d.id;
  //       //       q.category = 'Properties';
  //       //       q.dataFieldId = d.id;
  //       //       q.actions = [];
  //       //       actions.map((a) => {
  //       //         q.actions.push({id: a.id, name: a.name, showComparator: (a.name.toLowerCase() === 'value')});
  //       //       });
  //       //       trigger.queries.push(q);
  //       //     });
  //       //   });
  //       //   trigger.filters.push(f);
  //       //   triggers.push(trigger);
  //       // });
  //     }
  //     return triggers;
  //   });
  // }
}
